export const WEBENGAGE_EVENTS = {
    TP_SESSION_START: 'TestPlayer_session_start',
    TP_LANGUAGE_SELECTION: 'TestPlayer_language_selection',
    TP_START_TEST: 'TestPlayer_start_test',
    TP_SUBMIT_TEST: 'TestPlayer_submit_test',
    TP_AUTO_SUBMIT_TEST: 'TestPlayer_auto_submit_test',
}
